export const mainThemeJson = {
    direction: 'rtl',
    typography: {
        // fontFamily: 'Khand'
    },
    palette: {
        primary: {
            light: '#fff',
            main: '#0098ff',
            dark: '#020518',
            contrastText: '#000',
        },
        lightText: '#fff',
        secondary: {
            light: '#ffffff',
            main: '#fff',
            contrastText: '#fff',
        },
        primaryButton: {}
    },
    datePicker: {
        headerColor: '#0098ff'
    },
    components: {
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        color: '#fff',
                    },
                },
            },
        },
        MuiPickersYear: {
            styleOverrides: {
                yearButton: {
                    '&.Mui-selected': {
                        color: '#fff',
                    },
                },
            },
        },
    },
}